import React from 'react';
import {FeatureBoxOne} from '../../components/';
import Slider from 'react-slick';

const FeatureOne = ({className})=> {

  const settings = {
    autoplay: true,
    autoplaySpeed: 8000,
    infinite: true,
    arrows: false,
    speed: 1000,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {          
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 992,
        settings: {          
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 767,
        settings: {          
          slidesToShow: 1,
        }
      }
    ]
  };
  
  return (
    <div className={`feature-wrap1 ${className || ''}`}>
      <div className="container">   
        <Slider className="row" {...settings}>
          <FeatureBoxOne 
            title="Portal Development Services"
            text="Our software solution is customizeable portal management systems for schools, colleges, and universities — covering admissions, student records, academics, and administration in one smart platform."
            image="images/icon/fe-1-1.png"
            path="/about"
          />
          <FeatureBoxOne 
            title="Learning & Testing Solutions"
            text="From e-learning platforms to secure computer-based testing (CBT) systems, our solution has an end-to-end digital tools that modernize how students learn, take exams, and access academic content."
            image="images/icon/fe-1-2.png"
            path="/about"
          />
          <FeatureBoxOne 
            title="Institutional Technology Consulting"
            text="Let us help you navigate the digital landscape with expert guidance on edu-technology. We help institutions on software integration, digital transformation, and IT infrastructure. "
            image="images/icon/fe-1-3.png"
            path="/about"
          />
        </Slider>
      </div>
    </div>
  );
}

export default FeatureOne;